export type NotificationType = "lead" | "call" | "alert" | "whatsapp" | "assignment" | "score" | "integration" | "system";

export interface NotificationItem {
  id: number;
  type: NotificationType;
  title: string;
  description: string;
  time: string;
  read: boolean;
}

export const notificationTypeConfig: Record<NotificationType, { icon: string; bg: string; color: string }> = {
  lead:        { icon: "ri-user-add-line",      bg: "bg-indigo-100", color: "text-indigo-600" },
  call:        { icon: "ri-phone-line",          bg: "bg-green-100",  color: "text-green-600" },
  alert:       { icon: "ri-error-warning-line",  bg: "bg-red-100",    color: "text-red-600" },
  whatsapp:    { icon: "ri-whatsapp-line",       bg: "bg-green-100",  color: "text-green-600" },
  assignment:  { icon: "ri-shuffle-line",         bg: "bg-amber-100",  color: "text-amber-600" },
  score:       { icon: "ri-flashlight-line",     bg: "bg-purple-100", color: "text-purple-600" },
  integration: { icon: "ri-plug-line",           bg: "bg-blue-100",   color: "text-blue-600" },
  system:      { icon: "ri-settings-3-line",     bg: "bg-gray-100",   color: "text-gray-600" },
};

export const notificationsData: NotificationItem[] = [
  {
    id: 1, type: "lead", read: false,
    title: "New lead from IndiaMart Mumbai",
    description: "Vikram Mehta — ₹24,500 — Auto-assigned to Rajesh Kumar",
    time: "2 mins ago",
  },
  {
    id: 2, type: "call", read: false,
    title: "Missed call from Anita Desai",
    description: "9845123456 — Called at 10:15 AM — Needs callback",
    time: "15 mins ago",
  },
  {
    id: 3, type: "alert", read: false,
    title: "Stale lead alert",
    description: "Sunita Rao has had no activity for 12 days — Proposal Sent stage",
    time: "1 hr ago",
  },
  {
    id: 4, type: "whatsapp", read: false,
    title: "New WhatsApp message",
    description: "Vikram Mehta: Yes please, also interested in 3BHK, budget 80L",
    time: "1 hr ago",
  },
  {
    id: 5, type: "assignment", read: false,
    title: "Lead reassigned to you",
    description: "Manoj Tiwari was reassigned from Priya Sharma to you",
    time: "2 hrs ago",
  },
  {
    id: 6, type: "score", read: false,
    title: "Lead score increased",
    description: "Kavita Joshi score jumped to 92 — Now a Hot Lead",
    time: "3 hrs ago",
  },
  {
    id: 7, type: "integration", read: false,
    title: "TradeIndia webhook error",
    description: "Connection timeout — 0 leads received in last 2 hours",
    time: "3 hrs ago",
  },
  {
    id: 8, type: "lead", read: true,
    title: "New lead from JustDial Pune",
    description: "Arjun Kapoor — ₹7,200",
    time: "Yesterday 4:30 PM",
  },
  {
    id: 9, type: "call", read: true,
    title: "Call completed — 8m 12s",
    description: "Kavita Joshi — Connected — Recording available",
    time: "Yesterday 4:30 PM",
  },
  {
    id: 10, type: "system", read: true,
    title: "Assignment rules updated",
    description: "IndiaMart Pune → Priya rule added by Rajesh Kumar",
    time: "Yesterday 2:00 PM",
  },
  {
    id: 11, type: "lead", read: true,
    title: "Lead stage updated",
    description: "Suresh Nair moved to Site Visit Done",
    time: "Yesterday 11:00 AM",
  },
  {
    id: 12, type: "whatsapp", read: true,
    title: "WhatsApp message delivered",
    description: "Deepika Singh received site visit confirmation — 3 PM tomorrow",
    time: "Yesterday 10:15 AM",
  },
  {
    id: 13, type: "call", read: true,
    title: "Call rescheduled",
    description: "Priya Nambiar rescheduled to Friday 11 AM — Site Visit",
    time: "2 days ago",
  },
  {
    id: 14, type: "score", read: true,
    title: "Lead score decreased",
    description: "Arjun Kapoor score dropped to 28 — Marked as Lost",
    time: "2 days ago",
  },
  {
    id: 15, type: "system", read: true,
    title: "Report generated",
    description: "Monthly pipeline report ready — May 2026 summary available",
    time: "3 days ago",
  },
];